import { DocumentHubNode } from 'src/features/document-hub/types';

import type { PamEvidenceDocument, PamPendingEvidenceUpload } from './api/types';

/** Server-side page size for PAM evidence document lists (flat + folder question level). */
export const PAM_EVIDENCE_PAGE_SIZE = 12;

export function evidenceDocumentNode(doc: PamEvidenceDocument): DocumentHubNode {
  return {
    id: doc.document_id,
    name: doc.name,
    type: 'file',
    folder_type: null,
    read_only: true,
    parent_id: null,
    mime_type: doc.mime_type,
    document_type: doc.document_type,
    updated_at: doc.updated_at,
    document_id: doc.document_id
  };
}

export function pendingEvidenceUploadNode(p: PamPendingEvidenceUpload): DocumentHubNode {
  return {
    id: `pending:${p.upload_id}`,
    name: p.name,
    type: 'file',
    folder_type: null,
    read_only: true,
    parent_id: null,
    uploading: true
  };
}

export function optimisticEvidenceUploadNode(key: string, name: string): DocumentHubNode {
  return {
    id: `optimistic:${key}`,
    name,
    type: 'file',
    folder_type: null,
    read_only: true,
    parent_id: null,
    uploading: true
  };
}
